<section class="academic-integrity-section">
  <div class="container">
    <div class="content-wrapper">
      <div class="text-content">
        <h2 class="section-title">{{ title }}</h2>
        <h3 class="section-subtitle">{{ subtitle }}</h3>
        <p class="section-description">{{ description }}</p>
        <div class="cta-wrapper">
          <a [href]="ctaLink" class="cta-button" target="_blank" role="button">
            {{ ctaText }}
          </a>
        </div>
      </div>
      <div class="video-content">
        <div class="video-wrapper">
          <div class="video-container">
            <iframe
              [src]="videoEmbedUrl"
              [title]="videoTitle"
              allowfullscreen
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              class="video-frame"
              loading="lazy"
            >
            </iframe>
          </div>
          <!-- Always show a styled preview overlay -->
          <div class="video-preview-overlay">
            <div class="preview-content">
              <div class="preview-image">
                <img
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=560&h=315&q=80"
                  alt="Academic integrity and secure testing"
                  class="preview-img"
                />
              </div>
              <div class="video-info">
                <div class="play-button">
                  <svg width="72" height="72" viewBox="0 0 24 24" fill="white">
                    <circle cx="12" cy="12" r="10" fill="rgba(6, 0, 180, 0.9)" />
                    <path d="M10 8l6 4-6 4V8z" fill="white" />
                  </svg>
                </div>
                <div class="video-details">
                  <h4>{{ videoTitle }}</h4>
                  <p>Learn how Respondus integration enhances exam security in Achieve</p>
                  <span class="duration">5:24</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
